var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconPlay = function SvgIconPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.244 8.915c.953.6.956 1.57 0 2.17l-10.517 6.61C4.773 18.293 4 17.86 4 16.747V3.252c0-1.122.771-1.547 1.727-.946l10.517 6.609z",
    fillRule: "evenodd"
  })));
};

export default SvgIconPlay;